import { Environment } from '@abp/ng.core';
const baseUrl = 'http://localhost:4200';
const oAuthConfig = {
  issuer: 'https://dev-auth.nextere.com/',
  redirectUri: baseUrl,
  clientId: 'Onboarding_CRM_Angular',
  responseType: 'code',
  scope:
    'offline_access openid profile email phone AccountService IdentityService AdministrationService SaasService ProductService CoredataService NotificationService CRMService TaskService ConsentService LeadService',
  requireHttps: true,
};
const KENDO_UI_LICENSE = 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkxJQyJ9.eyJwcm9kdWN0cyI6W3sidHJpYWwiOmZhbHNlLCJjb2RlIjoiS0VORE9VSVJFQUNUIiwibGljZW5zZUV4cGlyYXRpb25EYXRlIjoxNzQyMzUxNTg5fSx7InRyaWFsIjpmYWxzZSwiY29kZSI6IktFTkRPVUlDT01QTEVURSIsImxpY2Vuc2VFeHBpcmF0aW9uRGF0ZSI6MTc0MjM1MTU4OX0seyJ0cmlhbCI6ZmFsc2UsImNvZGUiOiJLRU5ET1VJVlVFIiwibGljZW5zZUV4cGlyYXRpb25EYXRlIjoxNzQyMzUxNTg5fSx7InRyaWFsIjpmYWxzZSwiY29kZSI6IktFTkRPVUlBTkdVTEFSIiwibGljZW5zZUV4cGlyYXRpb25EYXRlIjoxNzQyMzUxNTg5fV0sImludGVncml0eSI6InNkbHY3bEFhbTFPdFZvb3hUWEhwWEQxTVZIMD0iLCJsaWNlbnNlSG9sZGVyIjoiY29udGFjdEBuZXh0ZXJlLmNvbSIsImlhdCI6MTcxMzE1ODYzNCwiYXVkIjoicmFpc2FobWFkLm1hbnN1cmlAYXZpYXNvbGUuY29tIiwidXNlcklkIjoiZDcwNDRkMjAtZTMwYS00MzgxLWJlMzEtNmUyZjA5YjIwMzlhIn0.VLSt93MMpkLmLc2YWWevD0s5JPUZrEKeRzNG_7lKk6lIhLifLPN3aoWlmm0TnAcGYKImo9eh-HzrXOTbmu5lCxfZt6EsAPeS0psL_8Zqc3MZmVZ_vzT8hFrSVzEmO6q-GiFJNC8N5NnL_rwVebgR2tAt9PSLZtY37lW-CpnUiIKahQ-b1e3t_piZ23pytr1iqLMuqeFwGyV5rNuXrfcTgpawR3k9IzBhZotcqJpG85AR4UKNpiuAkYo3jAh3ev183qLfVyWUwLj-9MCVvc926VM7fOqk4Ks0IbZzGBC7K7hzU3EbMedlja0CrmYMQ7I9Av1sA8jcRx6OImmu9MC2eQ'
export const environment = {
  production: false,
  idleTimeoutSeconds: 7200,
  application: {
    baseUrl,
    name: 'Onboarding',
  },
  KENDO_UI_LICENSE,
  logoutURL: 'https://dev-auth.nextere.com/assets/logout.html',
  clarityProjectId: null,
  onboardingURL : 'https://app-dev.nextere.com/' ,
  commissionURL : 'https://commission-dev.nextere.com/' ,
  nexquotingURL : 'https://dev.nexquoting.com/',
  signURL: 'https://sign-server-dev.nextere.com/',
  phoneURL: 'https://phone-dev.nextere.com/',
  edeURL: 'https://ede-fe-dev.nextere.com/',
  widgetURL: 'https://gateway-dev.nextere.com/api/zoho-token/generate-jwt?projectType=2',
  cryptoSecretKey: '4f8e7a14c1b23d5e8e9f4d2b1c6e8d2a',
  conXentURL: 'https://consent-dev.nextere.com/',
  smsURL:'https://sms-dev.nextere.com/',
  quotingAI: 'https://quoting-tool.jollywater-cf68a1ff.westus2.azurecontainerapps.io',
  oAuthConfig,
  apis: {
    default: {
      url: 'https://gateway-dev.nextere.com',
      rootNamespace: 'Onboarding',
    },
    AbpAccountPublic: {
      url: oAuthConfig.issuer,
      rootNamespace: 'AbpAccountPublic',
    },
    ProductService: {
      url: 'https://product-onboard.gleeze.com',
      rootNamespace: 'Onboarding',
    },
    CoredataService: {
      url: 'https://coredata-onboard.gleeze.com',
      rootNamespace: 'Onboarding',
    },
    IdentityServer: {
      url: 'https://identity-onboard.gleeze.com',
      rootNamespace: 'Onboarding',
    },
    CommissionService: {
      url: 'https://onboarding-commission.gleeze.com',
      rootNamespace: 'Onboarding',
    },
    // NotificationService: {
    //   url: 'https://notification-onboard.gleeze.com',
    //   rootNamespace: 'Onboarding',
    // },
  },
} as Environment;
